import axios from 'assets/js/axios'
import PropTypes from 'prop-types'
import { getToken } from 'assets/js/auth'
import { useCallback } from 'react'

export default function useSearch(routes, responseProcessor) {
  const fetch = useCallback(
    async (term, param) => {
      const accessToken = getToken()
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }

      let params = {
        [param && param[0]]: term
      }

      if (term && term.match(/[0-9]/)) {
        params = {
          [param && param[1]]: term
        }
      }
      const response = await axios.get(
        routes.list,
        term ? { params, headers } : { params: { pageSize: 5000 }, headers }
      )

      if (responseProcessor) {
        return response.data.map(item => responseProcessor(item))
      }
      return response.data
    },
    [responseProcessor, routes.list]
  )

  return fetch
}

useSearch.propTypes = {
  responseProcessor: PropTypes.func,
  routes: PropTypes.shape({
    list: PropTypes.string.isRequired,
    searchParams: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]).isRequired,
    getById: PropTypes.string
  })
}
